import { motion } from "framer-motion";

/**
 * Full-bleed PaintKing brand banner. Sits between Hero and the top marquee.
 */
export default function BrandBanner() {
    return (
        <section
            data-testid="brand-banner"
            className="relative w-full overflow-hidden bg-black"
        >
            <motion.div
                initial={{ opacity: 0, scale: 1.04 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 1.4, ease: [0.19, 1, 0.22, 1] }}
                className="relative"
            >
                <img
                    src="/paintking-banner.webp"
                    alt="PaintKing — Residential & Commercial painting in South Florida"
                    className="w-full h-auto block select-none"
                    loading="lazy"
                />

                {/* Soft top + bottom fade so it blends with the black sections above/below */}
                <div className="absolute inset-x-0 top-0 h-16 md:h-24 bg-gradient-to-b from-black to-transparent pointer-events-none" />
                <div className="absolute inset-x-0 bottom-0 h-16 md:h-24 bg-gradient-to-t from-black to-transparent pointer-events-none" />
            </motion.div>
        </section>
    );
}
